"use strict";

const productionConfig = {
  NAME: "AAUTI SOCIAL CORE PRODUCTION",
  ENV: "production",
  SOCIAL_API_URL: "YOUR_SOCIAL_API_URL",
  SOCIAL_TENANT_ID: "YOUR_SOCIAL_TENANT_ID"
};
export default productionConfig;
//# sourceMappingURL=production.js.map